import { useTranslation } from "react-i18next";
import "./style.css";
import { Block } from "@/components/crRender";
import { translate } from "@/utils/langUtils";

interface FlowStep {
  key: number;
  label: string;
}

interface CRRequestFlowProps {
  steps: FlowStep[];
  currentStep: number;
}

const CRRequestFlow: React.FC<CRRequestFlowProps> = ({
  steps,
  currentStep,
}) => {
  const currentIndex =  steps?.findIndex((s) => s.key == currentStep);

  const { i18n } = useTranslation();

  return (
    <div className="cr-flow">
      {steps?.map((step, index) => {
        const isDone = index < currentIndex;
        const isActive = index === currentIndex;
        return (
          <div className="cr-flow-item" key={step.key}>
            <div className="cr-flow-top">
              <div className={`cr-flow-dot ${isDone ? "done" : ""} ${isActive ? "active" : ""}`}>
                {isDone && "✓"}
              </div>
              <Block isRender={index !== steps.length - 1} className={`cr-flow-line ${i18n.language} ${index < currentIndex ? "done" : ""}`} />
            </div>

            <div className={`cr-flow-label ${isActive ? "active" : ""}`} >
              {translate(step.label)?.toUpperCase()}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default CRRequestFlow;
